<template>
  <div class="px-sm-4">
    <b-card>
      <b-card-header
        class="align-items-start flex-sm-row flex-column-reverse mb-3"
      >
        <b-card-title class="mt-sm-0 mt-2"> Partner documents </b-card-title>

        <b-link
          :to="{
            name: 'partners',
          }"
        >
          <span>back to the partner list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <b-row class="flex-wrap" v-if="loadDocuments">
          <b-col
            md="4"
            cols="12"
            class="d-flex flex-column justify-content-center align-items-center mb-2"
            v-for="i in 3"
            :key="i"
          >
            <b-skeleton width="100%" height="250px" class="rounded" />
          </b-col>
        </b-row>
        <template v-else-if="documents.length">
          <b-row class="flex-wrap">
            <b-col
              md="4"
              cols="12"
              v-if="idCartBack"
              class="d-flex flex-column justify-content-center align-items-center mb-2"
            >
              <b-card-title class="mt-sm-0 mt-2 mb-0"> Front </b-card-title>
              <div
                style="max-width: 300px; height: 250px"
                class="d-flex justify-content-center align-items-center"
              >
                <b-img
                  @click="showImg(idCartFront.url)"
                  class="img-fluid rounded-lg my-1 cursor-pointer"
                  :src="idCartFront.url || errorImage"
                  @error="setAltImg"
                  alt="id-cart-front"
                  style="max-height: 250px"
                />
              </div>
              <b-form-group
                label-for="status"
                class="w-100 pt-1"
                label="Change the current status"
              >
                <b-button-group class="mt-1 d-flex justify-content-center">
                  <button
                    class="btn text-white px-1 mx-25 hover-success"
                    :class="
                      idCartFrontStatus == 'ACCEPTED' ? 'bg-success' : '  '
                    "
                    @click="idCartFrontStatus = 'ACCEPTED'"
                  >
                    Accepted
                  </button>
                  <button
                    class="btn text-white px-1 mx-25 hover-danger"
                    :class="
                      idCartFrontStatus == 'REJECTED' ? 'bg-danger' : '  '
                    "
                    @click="idCartFrontStatus = 'REJECTED'"
                    style="
                      border-top-right-radius: 20px;
                      border-bottom-right-radius: 20px;
                    "
                  >
                    Rejected
                  </button>
                </b-button-group>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              cols="12"
              v-if="idCartBack"
              class="d-flex flex-column justify-content-center align-items-center mb-2"
            >
              <b-card-title class="mt-sm-0 mt-2 mb-0"> Back </b-card-title>
              <div
                style="max-width: 300px; height: 250px"
                class="d-flex justify-content-center align-items-center"
              >
                <b-img
                  @click="showImg(idCartBack.url)"
                  class="img-fluid rounded-lg my-1 cursor-pointer"
                  :src="idCartBack.url || errorImage"
                  @error="setAltImg"
                  alt="id-cart-front"
                  style="max-height: 250px"
                />
              </div>
              <b-form-group
                label-for="status"
                class="w-100 pt-1"
                label="Change the current status"
              >
                <b-button-group class="mt-1 d-flex justify-content-center">
                  <button
                    class="btn text-white px-1 mx-25 hover-success"
                    :class="
                      idCartBackStatus == 'ACCEPTED' ? 'bg-success' : '  '
                    "
                    @click="idCartBackStatus = 'ACCEPTED'"
                  >
                    Accepted
                  </button>

                  <button
                    class="btn text-white px-1 mx-25 hover-danger"
                    :class="idCartBackStatus == 'REJECTED' ? 'bg-danger' : '  '"
                    @click="idCartBackStatus = 'REJECTED'"
                    style="
                      border-top-right-radius: 20px;
                      border-bottom-right-radius: 20px;
                    "
                  >
                    Rejected
                  </button>
                </b-button-group>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              cols="12"
              v-if="portrait"
              class="d-flex flex-column justify-content-center align-items-center mb-2"
            >
              <b-card-title class="mt-sm-0 mt-2 text-left mb-0">
                Selfie
              </b-card-title>
              <div
                style="max-width: 300px; height: 250px"
                class="d-flex justify-content-center align-items-center"
              >
                <b-img
                  @click="showImg(portrait.url)"
                  class="img-fluid rounded-lg my-1 cursor-pointer"
                  :src="portrait.url || errorImage"
                  @error="setAltImg"
                  alt="id-cart-front"
                  style="max-height: 250px"
                />
              </div>
              <b-form-group
                label-for="status"
                class="w-100 pt-1"
                label="Change the current status"
              >
                <b-button-group class="mt-1 d-flex justify-content-center">
                  <button
                    class="btn text-white px-1 mx-25 hover-success"
                    :class="portraitStatus == 'ACCEPTED' ? 'bg-success' : '  '"
                    @click="portraitStatus = 'ACCEPTED'"
                  >
                    Accepted
                  </button>
                  <button
                    class="btn text-white px-1 mx-25 hover-danger"
                    :class="portraitStatus == 'REJECTED' ? 'bg-danger' : '  '"
                    @click="portraitStatus = 'REJECTED'"
                    style="
                      border-top-right-radius: 20px;
                      border-bottom-right-radius: 20px;
                    "
                  >
                    Rejected
                  </button>
                </b-button-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="w-100 d-flex align-items-center justify-content-end">
            <b-button @click="changeStatuses" class="gradient-btn">
              {{ "Change status" }}
            </b-button>
          </div>

          <template v-if="others.length">
            <div>
              <hr class="my-2" />
            </div>
            <div>
              <b-card-title class="mt-sm-0 mt-2"> Others </b-card-title>
            </div>
            <b-row class="flex-wrap">
              <b-col
                md="3"
                cols="12"
                v-for="(other, index) in others"
                :key="index"
                class="d-flex flex-column justify-content-center align-items-center mb-2"
              >
                <div
                  style="max-width: 300px; height: 250px"
                  class="d-flex justify-content-center align-items-center"
                >
                  <b-img
                    @click="showImg(other.url)"
                    class="img-fluid rounded-lg mb-1 cursor-pointer"
                    :src="other.url || errorImage"
                    @error="setAltImg"
                    alt="other"
                    style="max-height: 250px"
                  />
                </div>
              </b-col>
            </b-row>
          </template>
        </template>
        <template v-else>
          <div
            class="d-flex align-items-center justify-content-center h-100 new-alert"
          >
            <b-alert
              show
              variant="secondary"
              class="d-flex align-items-center justify-content-center p-3 w-100"
            >
              no information
            </b-alert>
          </div>
        </template>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
    <b-modal
      v-model="showModal"
      hide-footer
      centered
      size="xl"
      title="Image preview"
      title-class="h3"
    >
      <div class="p-4 d-flex justify-content-center align-items-center">
        <b-img :src="imgPreview" fluid />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BLink,
  BImg,
  BSkeleton,
  BButtonGroup,
  BFormGroup,
  BAlert,
  BModal,
} from "bootstrap-vue";
import Loader from "@/@core/components/loader/Loader.vue";
import qs from "qs";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BLink,
    BImg,
    BSkeleton,
    Loader,
    BButtonGroup,
    BFormGroup,
    BAlert,
    BModal,
  },
  data() {
    return {
      loading: false,
      loadDocuments: false,
      documents: [],
      idCartFrontStatus: "",
      idCartBackStatus: "",
      portraitStatus: "",
      showModal: false,
      imgPreview: "",
    };
  },
  created() {
    this.getDocuments();
  },
  computed: {
    idCartFront() {
      let index = this.documents.findIndex(
        (item) => item.type == "ID_CARD_FRONT"
      );
      this.documents[index] &&
        this.documents[index].status &&
        (this.idCartFrontStatus = this.documents[index].status);
      return index > -1 ? this.documents[index] : false;
    },
    idCartBack() {
      let index = this.documents.findIndex(
        (item) => item.type == "ID_CARD_BACK"
      );
      this.documents[index] &&
        this.documents[index].status &&
        (this.idCartBackStatus = this.documents[index].status);
      return index > -1 ? this.documents[index] : false;
    },
    portrait() {
      let index = this.documents.findIndex((item) => item.type == "PORTRAIT");
      this.documents[index] &&
        this.documents[index].status &&
        (this.portraitStatus = this.documents[index].status);
      return index > -1 ? this.documents[index] : false;
    },
    others() {
      return this.documents.filter((item) => item.type == "OTHER");
    },
  },
  methods: {
    showImg(url) {
      this.imgPreview = url;
      this.showModal = true;
    },
    async changeStatuses() {
      this.loading = true;
      let requests = [
        this.changeStatus(this.portrait.id, this.portraitStatus),
        this.changeStatus(this.idCartBack.id, this.idCartBackStatus),
        this.changeStatus(this.idCartFront.id, this.idCartFrontStatus),
      ];
      await Promise.all(requests);
      await this.getDocuments();
      this.loading = false;
    },
    async changeStatus(id, status) {
      try {
        const { data } = await this.$http.post(
          `/panel/documents/${id}?_method=put`,
          {
            status: status,
          }
        );
      } catch (error) {}
    },
    async getDocuments() {
      this.loadDocuments = true;
      try {
        let filter = {
          model: {
            type: "partner",
            id: this.$route.params.id,
          },
        };
        const { data } = await this.$http.get(`/panel/documents`, {
          params: {
            filter,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.documents = data.data;
      } catch (err) {}
      this.loadDocuments = false;
    },
  },
};
</script>
<style scoped>
.btn {
  background-color: #252531;
  border: 1px solid #ffffff0d;
}
</style>
